import React, { useEffect, useRef, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { ANNOTATION_ACTION } from "@/features/tutor/constants";
import { useAnnotation } from "@/features/tutor/hooks/useAnnotation";
import { debugLog, debugWarn } from "@/utils/debugLog";

const HtmlViewer = () => {
  const { "*": htmlPath } = useParams();
  const location = useLocation();
  const containerRef = useRef(null);
  const { wrapElement } = useAnnotation();
  const [html, setHtml] = useState("");

  debugLog("htmlPath: ", htmlPath);

  useEffect(() => {
    const loadHtml = async () => {
      try {
        const response = await fetch(`/slides/${htmlPath}`);
        const htmlContent = await response.text();

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlContent;

        // Check if MathJax is loaded and initialized
        if (window.MathJax && window.MathJax.typesetPromise) {
          // typeset mathjax
          await window.MathJax.typesetPromise([tempDiv]);
        } else {
          debugWarn("MathJax not loaded or initialized");
        }

        // reveal all elements
        const elementsWithInvisible =
          tempDiv.getElementsByClassName("invisible");
        while (elementsWithInvisible.length > 0) {
          elementsWithInvisible[0].classList.remove("invisible");
        }

        setHtml(tempDiv.innerHTML);
      } catch (error) {
        console.error("Error loading HTML:", error);
        setHtml("");
      }
    };

    loadHtml();
  }, [htmlPath]);

  useEffect(() => {
    if (containerRef.current) {
      // add annotations synchronously
      const elements =
        containerRef.current.querySelectorAll("[data-annotation]");
      elements.forEach((element) => {
        const annotationType = element.getAttribute("data-annotation");
        const color = element.getAttribute("data-color") || "#FFAB00";
        const action = ANNOTATION_ACTION[annotationType.toUpperCase()];
        if (action) {
          if (!element.hasAttribute("data-annotated")) {
            wrapElement(element, action, 0, color, false, false);
            element.setAttribute("data-annotated", "true");
          }
        }
      });
    }
  }, [html]);

  return (
    <div className="w-full h-full">
      <div
        ref={containerRef}
        className="html-content-container w-full h-full overflow-hidden relative z-0 flex flex-col"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
};

export default HtmlViewer;
